import { SectionLabel, MetricRow } from "@/features/simulations/sandbox/results/result-primitives";
import type { InterpretationFacts, InterpretationKpiSet } from "@/types/interpretation.types";

// KPIs da rodada vs referência (baseline/"você está aqui"). OEE/A/P/Q em %, produção em unidades.
// Reusa MetricRow/DeltaValue (delta colorido + acessível) do sandbox — mesma linguagem visual.

function pct(n: number | null): string {
  return n == null ? "—" : `${n.toFixed(1)}%`;
}
function int(n: number | null): string {
  return n == null ? "—" : Math.round(n).toLocaleString("pt-BR");
}
function round1(n: number | null): number | null {
  return n == null ? null : Math.round(n * 10) / 10;
}
function delta(cur: number | null, ref: number | null): number | null {
  return cur != null && ref != null ? round1(cur - ref) : null;
}

export function KpiSection({
  kpis,
  verdict,
  stopCost,
}: {
  kpis: InterpretationFacts["kpis"];
  verdict: InterpretationFacts["verdict"];
  stopCost: InterpretationFacts["stopCost"];
}): React.ReactElement {
  const c: InterpretationKpiSet = kpis.current;
  const r = kpis.reference;
  const noRef = r == null;
  return (
    <section>
      <SectionLabel>Indicadores {noRef ? "(sem referência)" : "vs. referência"}</SectionLabel>
      <div>
        <MetricRow
          label="OEE"
          value={pct(c.oee)}
          delta={round1(verdict.oeeDeltaPp)}
          isBase={noRef}
        />
        <MetricRow
          label="Disponibilidade"
          value={pct(c.availability)}
          delta={delta(c.availability, r?.availability ?? null)}
          isBase={noRef}
        />
        <MetricRow
          label="Performance"
          value={pct(c.performance)}
          delta={delta(c.performance, r?.performance ?? null)}
          isBase={noRef}
        />
        <MetricRow
          label="Qualidade"
          value={pct(c.quality)}
          delta={delta(c.quality, r?.quality ?? null)}
          isBase={noRef}
        />
        <MetricRow
          label="Produção"
          value={int(c.estimatedProduction)}
          delta={verdict.productionDelta}
          unit="un"
          isBase={noRef}
        />
      </div>
      {stopCost ? (
        <p className="mt-2 text-[12px] text-muted-foreground">
          Custo de parada estimado:{" "}
          <span className="font-mono font-medium text-text-secondary">
            {stopCost.estimated.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}
          </span>{" "}
          <span className="text-[11px]">({stopCost.method})</span>
        </p>
      ) : null}
    </section>
  );
}
